import React, { useMemo } from "react";
import TableData from "./tableData";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  ACCESS_DENIED,
  VIEW_INSPECTION_REPORT,
} from "../../../constant/routeContant";
import { getInspectionViewListFilterObj } from "../../../redux/actions/incpectionAction";
import { getPreviousRoute } from "../../../utils/routeTracker";

const InspectionViewReport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const detail = location?.state;

  useMemo(() => {
    const currentPathname = location.pathname;
    if (currentPathname === VIEW_INSPECTION_REPORT) {
      const previousRoute = getPreviousRoute();
       const isFromInspectionModule =
       previousRoute && previousRoute.startsWith("/inspection");

      if (previousRoute && !isFromInspectionModule) {
        dispatch(getInspectionViewListFilterObj(null));
      }
    }
  }, [location.pathname, dispatch]);

  return (
    <>
      {checkPrivileges([12, 16, 4, 5, 6]) ? (
        <TableData detail={detail} />
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
};

export default InspectionViewReport;
